import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import httpService from '@/services/core/http.service';

export const COMPANY_SEARCH_MIN_CHARS = 3;

/**
 * Remote company typeahead: backend search after 3 chars, top 4 results.
 * Does not preload the full company list.
 */
export function createCompanySearchDataSource() {
    return new DataSource({
        store: new CustomStore({
            key: 'id',
            load: loadOptions => {
                const q = (loadOptions.searchValue || '').trim();
                if (q.length < COMPANY_SEARCH_MIN_CHARS) return Promise.resolve([]);
                return httpService.get('companies/search', { q });
            },
            byKey: key => {
                const id = parseInt(key, 10);
                if (!Number.isFinite(id) || id <= 0) return Promise.resolve(null);
                return httpService.get(`companies/${id}`).then(company => {
                    if (!company) return null;
                    return { id: String(company.id), name: company.name };
                });
            }
        }),
        paginate: false
    });
}